import { useEffect } from "react";

const useOutsideClick = (ref, callback) => {
  const handleClick = e => {
    if (ref.current && !ref.current.contains(e.target)) {
      callback(ref);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  });
};


export const useOutsideOver = (ref, callback) => {
  const handleClick = e => {
    if (ref.current && !ref.current.contains(e.target)) {
      callback(ref);
    }
  };

  useEffect(() => {
    document.addEventListener("mouseover", handleClick);

    return () => {
      document.removeEventListener("mouseover", handleClick);
    };
  });
};

export default useOutsideClick;